import '../FAQ/styles.css'
import { Accordion } from '../FAQ/Accordion/index';

export function Faq() {
  return (
    <div style={{background: '#E6EFF9'}}>
    <div className="faqContainer" id="faq">
      <div className="textButtonAcc">
        <h2>DÚVIDAS FREQUENTES</h2>
      </div>

      <Accordion title='Como funciona o aplicativo?'>
      O <strong>Busca Saúde</strong> é um aplicativo focado na busca de profissionais de saúde. 
      Ele ajuda pacientes a se conectarem com os melhores profissionais de saúde da sua região.</Accordion>
      
      <Accordion title='Quais as vantagens para o paciente?'>
      
      O <strong>Busca Saúde</strong> visa oferecer aos seus usuários de forma confortável, informações sobre os profissionais da saúde que possivelmente sejam do interesse de cada indivíduo, considerando suas preferências de filtragem e localização geográfica. O sistema poderá permitir ao usuário a descoberta de especialistas da saúde, além da colaboração com outros usuários ao fornecer suas avaliações sobre o atendimento recebido, inserir comentários e classificar cada etapa do atendimento.
      </Accordion>

      <Accordion title='Quais as vantagens para o profissional?'>
      Encontrar atendimento de saúde especializado e de qualidade pode ser complexo, principalmente, quando estamos em uma região que não conhecemos, como outra cidade ou outro estado, e precisamos de socorro médico. Nessas situações, frequentemente pedimos informações a outras pessoas, mas nem sempre isso pode ser uma alternativa adequada. Com o <strong>Busca Saúde</strong>, você poderá ser facilmente encontrado por centenas de usuários que estão dentro da sua região. Além disso, o aplicativo será uma excelente ferramenta para profissionais que estão começando a carreira, divulgando seus trabalhos e permitindo que clientes possam dar opiniões sobre o atendimento recebido.
      </Accordion>
      

      <Accordion title='A plataforma é gratuita?'>
      O <strong>Busca Saúde</strong> é totalmente gratuito, tanto para paciente quanto para profissional da saúde.
      </Accordion>

      <Accordion title='Como é a negociação entre paciente e profissional?'>
      A plataforma <strong>não participa</strong> da negociação entre paciente e profissional. 
      Sendo que, a escolha do profissional para realizar uma consulta se dá unicamente pelo paciente.</Accordion>     
      

      <Accordion title='Como faço para aparecer na plataforma?'>
      Para fazer parte do <strong>Busca Saúde</strong> basta acessar a página de cadastro clicando  <a href="/register">aqui</a>. Após realizado o cadastro, iremos validar seus dados a fim de garantir a autenticidade das informações. Assim que seu cadastro for aprovado, você receberá um email avisando que você já é parceiro do <strong>Busca Saúde</strong> e estará aparecendo para milhares de pacientes.
      </Accordion>

    </div>
    </div>
  )
}